import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Location } from "@angular/common";
import { filter, Subscription } from "rxjs";
import { AuthService } from "../../../core/services/auth.service";
import { environment } from "environments/environment";
import {
  ROUTESUSERADMIN,
  ROUTESUSERNOADMIN,
} from "app/sidebar/sidebar.component";
import { LoadingIndicatorService } from "app/loading-indicator-service";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from "app/core/services/notification.service";
import { AlertService } from "app/core/services/alert.service";
import { UtilsRolesService } from "app/core/services/helpers/roles.component";

var misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};

@Component({
  moduleId: module.id,
  selector: "navbar-admin",
  templateUrl: "navbar-admin.component.html",
})
export class NavbarAdminComponent implements OnInit {
  private listTitles: any[];
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  private _router: Subscription;
  public open: boolean = false;
  loading: boolean = false;
  idCurrentUser: string = AuthService.getFromStorage("id");
  idTypeUser: string = AuthService.getFromStorage("typeUser");
  userName: string = AuthService.getFromStorage("username");
  numberNotifications: number = 0;
  public utilsRolesService: UtilsRolesService;

  @ViewChild("navbar", { static: false }) button;

  constructor(
    location: Location,
    public translate: TranslateService,
    private authService: AuthService,
    private renderer: Renderer2,
    private element: ElementRef,
    private router: Router,
    public notificationService: NotificationService,
    private loadingIndicatorService: LoadingIndicatorService,
    public alertService: AlertService
  ) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
    // change isLoading status whenever notified
    loadingIndicatorService.onLoadingChanged.subscribe(
      (isLoading) => (this.loading = isLoading)
    );
  }

  ngOnInit() {
    /*  if (this.havePermission("list-notifications-list")) {
      this.getNotifications();
    } */

    if (
      this.authService.getFromStorage(environment.storageTypeUserNameApi) ==
      "clientuser"
    ) {
      this.listTitles = ROUTESUSERADMIN.filter((listTitle) => listTitle);
    } else if (
      this.authService.getFromStorage(environment.storageTypeUserNameApi) ==
      "clientuserNoAdmin"
    ) {
      this.listTitles = ROUTESUSERNOADMIN.filter((listTitle) => listTitle);
    }

    const navbar: HTMLElement = this.element.nativeElement;
    const body = document.getElementsByTagName("body")[0];
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    if (body.classList.contains("sidebar-mini")) {
      misc.sidebar_mini_active = true;
    }
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const $layer = document.getElementsByClassName("close-layer")[0];
        if ($layer) {
          $layer.remove();
        }
      });
  }

  // Get Notifications
  getNotifications(): void {
    this.notificationService.getNotifications().subscribe({
      next: (response) => {
        this.numberNotifications = response.data.length;
      },
      error: (e) => {
        this.numberNotifications = 0;
        // this.alertService.error(e.error.msg, { autoClose: true });
      },
      complete: () => {},
    });
  }

  // Get Have permission
  havePermission(component1, component2 = null, component3 = null): boolean {
    return this.utilsRolesService.havePermission(component1);
  }

  changeLanguage(lang: string) {
    this.authService.saveLocalStorage(environment.storageLanguageNameApi, lang);
    this.translate.use(lang);
    setTimeout(function () {
      window.location.reload();
    }, 500);
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName("body")[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove("sidebar-mini");
      misc.sidebar_mini_active = false;
    } else {
      setTimeout(function () {
        body.classList.add("sidebar-mini");
        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  isMobileMenu() {
    if (window.outerWidth < 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    var toggleButton = this.toggleButton;
    var html = document.getElementsByTagName("html")[0];
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );
    if (window.innerWidth < 991) {
      mainPanel.style.position = "fixed";
    }
    html.classList.add("nav-open");
    this.sidebarVisible = true;
  }
  sidebarClose() {
    var html = document.getElementsByTagName("html")[0];
    this.toggleButton.classList.remove("toggled");
    this.sidebarVisible = false;
    html.classList.remove("nav-open");
    const mainPanel = <HTMLElement>(
      document.getElementsByClassName("main-panel")[0]
    );

    if (window.innerWidth < 991) {
      setTimeout(function () {
        mainPanel.style.position = "";
      }, 500);
    }
  }
  sidebarToggle() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName("body")[0];
    if (this.sidebarVisible == false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  getTitleAdmin() {
    if (!this.listTitles?.length) {
      return "menuItems.dashboard";
    }

    const currentPath = this.location
      .prepareExternalUrl(this.location.path())
      .replace(/^#/, "")
      .split("?")[0];
    const segments = currentPath.split("/").filter(Boolean);
    const parentPath = segments[1];
    const childPath = segments[2];

    if (!parentPath) {
      return this.listTitles[0]?.title || "menuItems.dashboard";
    }

    for (const parent of this.listTitles) {
      if (parent.path === parentPath) {
        if (!childPath || !parent.children?.length) {
          return parent.title;
        }

        const child = parent.children.find(
          (currentChild) => currentChild.path === childPath
        );

        return child?.title || parent.title;
      }
    }

    return this.listTitles[0]?.title || "menuItems.dashboard";
  }

  getPath() {
    return this.location.prepareExternalUrl(this.location.path());
  }

  /* Login */
  logout() {
    const id = Number(AuthService.getFromStorage("id"));
    this.authService.logout(id).subscribe({
      next: (response) => {
        this.authService.deleteAllStorage();
        this.router.navigateByUrl("/public/login");
      },
      error: (err) => {
        this.authService.deleteAllStorage();
        this.router.navigateByUrl("/public/login");
      },
      complete: () => {},
    });
  }
}
